/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import Card from '../../card'
import { ImageInline } from '../../image'
import Paragraph from '../../paragraph'
import VideoWrapper from '../../video-wrapper'

import { FlexCols, FlexCol, VStack } from '../../../styles/els'
import { formatImage, renderHTML, resolveButtons } from '../../../lib/helpers'

const Detail = (props) => {
  const {
    heading,
    subheading,
    details,
    ctaText,
    buttons,
    sectionColor,
    ...otherProps
  } = props

  return (
    <Card color={sectionColor}>
      <VStack space={[6, null, 8]}>
        {heading || subheading ? (
          <Paragraph
            heading={heading}
            hTier={3}
            text={subheading}
            align="center"
          />
        ) : null}
        {details && details.length > 0 ? (
          <div>
            {details.map((_detail, _i) => {
              const { title, detail } = _detail
              return (
                <div
                  key={_i}
                  sx={{
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: 'dark',
                    pt: 4,
                    pb: 7,
                  }}
                >
                  <FlexCols>
                    <FlexCol across={[1, null, 3]} base={[1, null, 8]}>
                      <h3 sx={{ variant: 'text.bold_28' }}>{title}</h3>
                    </FlexCol>
                    <FlexCol across={[1, null, 5]} base={[1, null, 8]}>
                      <Paragraph htmlText={detail} tTier={2} />
                    </FlexCol>
                  </FlexCols>
                </div>
              )
            })}
          </div>
        ) : null}
        {ctaText || buttons ? (
          <Paragraph
            text={ctaText}
            align="center"
            buttons={resolveButtons(buttons)}
          />
        ) : null}
      </VStack>
    </Card>
  )
}

export default Detail

/*

sectionColor
            heading
            subheading
            details {
              title
              detail
            }
            ctaText
            buttons {
              linksTo
              label
              internalLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              gradientColor
              externalLink
              email
            }
            */
